const userEn = {
    login: require('../../lang/en/user/SignIn').default,
    registration: require('../../lang/en/user/Registration').default,
    changePass: require('../../lang/en/user/ChangePassword').default,
    profile: require('../../lang/en/user/Profile').default,
    forgotPassword: require('../../lang/en/user/ForgotPassword').default,
};

export default userEn;